var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeIconQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.36328 9C2.36328 4.96278 5.63856 1.6875 9.67578 1.6875C13.713 1.6875 16.9883 4.96278 16.9883 9C16.9883 13.0372 13.713 16.3125 9.67578 16.3125C5.63856 16.3125 2.36328 13.0372 2.36328 9ZM9.67578 2.8125C6.25988 2.8125 3.48828 5.5841 3.48828 9C3.48828 12.4159 6.25988 15.1875 9.67578 15.1875C13.0917 15.1875 15.8633 12.4159 15.8633 9C15.8633 5.5841 13.0917 2.8125 9.67578 2.8125Z",
    fill: "#8493B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.67578 3.9375C9.98644 3.9375 10.2383 4.18934 10.2383 4.5V9H13.0508C13.3614 9 13.6133 9.25184 13.6133 9.5625C13.6133 9.87316 13.3614 10.125 13.0508 10.125H9.67578C9.36512 10.125 9.11328 9.87316 9.11328 9.5625V4.5C9.11328 4.18934 9.36512 3.9375 9.67578 3.9375Z",
    fill: "#8493B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIconQuestion);
export default __webpack_public_path__ + "static/media/timeIconQuestion.b4844a7fe3071177ee0bd288a088bc62.svg";
export { ForwardRef as ReactComponent };